
import { useEffect, useState } from 'react';

import Util, { Data } from 'service/util';

import LocationSelect from 'component/dropdown/LocationSelect';
import MediaTypeDropdown from 'component/dropdown/MediaTypeDropdown';

const EInvoiceSelectionFilter = ({onChange}) => {

  const [company,    setCompany  ] = useState('');
  const [district,   setDistrict ] = useState('');
  const [location,   setLocation ] = useState('');
  const [cd_license, setLicense  ] = useState('');
  const [srv_plan,   setPlan     ] = useState('');
  const [media_type, setMediaType] = useState('');
  const [due_lv,     setDueLevel ] = useState('');

  useEffect(() => {
    onChange({company, district, location, cd_license, srv_plan, media_type, due_lv});
  }, [company, district, location, cd_license, srv_plan, media_type, due_lv])

  return (<div className="box e-invoice-filter">
    <h4 className="box-head">過濾</h4>
    <div className="box-body">
      <label className="field-row company">
        <strong>公司</strong>
        <div>
          <select id="f-company" value={company}
            onChange={ e=>setCompany(e.target.value) }>
            <option value="">全部</option>
            { Data.company.map(com =>
              <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
            )}
          </select>
        </div>
      </label>
      <label className="field-row location">
        <strong>屋苑</strong>
        <div>
          <LocationSelect all noLabel by={'management'}
            district={district} location={location}
            onUpdate={(d,l) => { setDistrict(d); setLocation(l); }}
            />
        </div>
      </label>
      <label className="field-row license">
        <strong>車牌</strong>
        <div>
          <input value={cd_license} onChange={ e=>setLicense(e.target.value)} />
        </div>
      </label>
      <label className="field-row license">
        <strong>計劃</strong>
        <div>
          <select value={srv_plan} onChange={ e=>setPlan(e.target.value)}>
            <option value="">全部</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>
        </div>
      </label>
      <label className="field-row media-type">
        <strong>媒體類型</strong>
        <div>
          <MediaTypeDropdown value={media_type} onChange={setMediaType} />
        </div>
      </label>
      <label className="field-row due-lv">
        <strong>賬單類型</strong>
        <div>
          <select value={due_lv} onChange={ e=>setDueLevel(e.target.value)}>
            <option value="">全部</option>
            <option value={0}>藍</option>
            <option value={1}>黑</option>
            <option value={2}>紅</option>
          </select>
        </div>
      </label>
    </div>
  </div>);
}

export default EInvoiceSelectionFilter;